module.exports = __webpack_public_path__ + "static/img/2_IMG_20151228_163340.7c4a0008.jpg";